import React from "react";
import { CancelRun } from "../../../api/batchNotificationController";
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	AccordionActions,
	Icon,
	Typography,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Button,
} from "../../../common/MaterialComponent";
import Shared from "../../../common/shared";
import { ButtonPrimary } from "../../../common/sharedStyle";
import { useGetComponentStringsContext } from "../../../hooks/useGetComponentStrings";
import { PreSubmissionConfigurationModel } from "../../../models/BatchMessage/BatchMessageDetailModel";
import BatchMessageSchedulingDetailModel, {
	MessageDetail,
} from "../../../models/BatchMessage/BatchMessageSchedulingDetailModel";
import { TemplateListDataGridAccordion } from "../TemplateListDataGridAccordion/TemplateListDataGridAccordion";

export interface TemplateListDataGridExpandedRowProp {
	item: PreSubmissionConfigurationModel;
	batchMessages?: BatchMessageSchedulingDetailModel;
	getIsBatchMessageTypeSMS: boolean;
	getIsBatchMessageTypeWhatsApp: boolean;
	messageCancelEnabled: boolean;
	country: string;
	templateUpdateRequired: (val: boolean) => void;
	setMounted: (val: boolean) => void;
}

export const TemplateListDataGridExpandedRow: React.FC<TemplateListDataGridExpandedRowProp> = ({
	item,
	batchMessages,
	getIsBatchMessageTypeSMS,
	getIsBatchMessageTypeWhatsApp,
	messageCancelEnabled,
	country,
	templateUpdateRequired,
	setMounted,
}) => {
	enum CancelOptions {
		All,
		Next,
		Scheduled,
	}
	const [confirmDialogOpen, setConfirmDialogOpen] = React.useState<boolean>(
		false
	);
	const [
		confirmDialogOption,
		setConfirmDialogOption,
	] = React.useState<CancelOptions>(CancelOptions.All);

	const [
		confirmDialogMessageId,
		setConfirmDialogMessageId,
	] = React.useState<string>("");

	const cancelRecurringRuns = async () => {
		setMounted(false);
		templateUpdateRequired(true);
		switch (confirmDialogOption) {
			case CancelOptions.Scheduled:
			case CancelOptions.All: {
				if (batchMessages) {
					try {
						const res = await CancelRun(
							item.partitionKey,
							batchMessages.preSubmissionConfigurationId,
							confirmDialogMessageId,
							true
						);
						if (res.error) {
							Shared.showSnackbarMessage(res.error);
						} else {
							if (confirmDialogOption === CancelOptions.All)
								Shared.showSnackbarMessage(strings.cancelAllSuccess);
							else Shared.showSnackbarMessage(strings.cancelScheduledSuccess);
						}
					} catch (err) {
						Shared.showSnackbarMessage(err);
					}
				}
				break;
			}
			case CancelOptions.Next: {
				if (batchMessages) {
					try {
						const res = await CancelRun(
							item.partitionKey,
							batchMessages.preSubmissionConfigurationId,
							confirmDialogMessageId,
							false
						);
						if (res.error) {
							Shared.showSnackbarMessage(res.error);
						} else {
							Shared.showSnackbarMessage(strings.cancelNextSuccess);
						}
					} catch (err) {
						Shared.showSnackbarMessage(err);
					}
				}
				break;
			}
		}
	};

	const strings = useGetComponentStringsContext()
		.TemplateListDataGridExpandedRow;

	return (
		<div>
			{batchMessages ? (
				batchMessages.messages.map((m: MessageDetail, messageIndex: number) => {
					return (
						<React.Fragment key={m.id}>
							<Accordion>
								<AccordionSummary
									expandIcon={<Icon fontSize="large">expand_more</Icon>}
									aria-controls="panel1a-content"
								>
									<Typography>{m.title}</Typography>
								</AccordionSummary>
								<AccordionDetails>
									<TemplateListDataGridAccordion
										messageDetail={m}
										getIsBatchMessageTypeSMS={getIsBatchMessageTypeSMS}
										getIsBatchMessageTypeWhatsApp={
											getIsBatchMessageTypeWhatsApp
										}
										messageIndex={messageIndex}
										country={country}
									/>
								</AccordionDetails>
								{messageCancelEnabled &&
									m.isRecurring &&
									Shared.isUserGlobalAdminOrCountryAdmin && (
										<AccordionActions>
											<ButtonPrimary
												size="small"
												onClick={() => {
													setConfirmDialogMessageId(m.id);
													setConfirmDialogOption(CancelOptions.Next);
													setConfirmDialogOpen(true);
												}}
											>
												{strings.cancelNextRunBtn}
											</ButtonPrimary>
											<ButtonPrimary
												size="small"
												onClick={() => {
													setConfirmDialogMessageId(m.id);
													setConfirmDialogOption(CancelOptions.All);
													setConfirmDialogOpen(true);
												}}
											>
												{strings.cancelAllRunsBtn}
											</ButtonPrimary>
										</AccordionActions>
									)}
								{messageCancelEnabled &&
									!m.isRecurring &&
									Shared.isUserGlobalAdminOrCountryAdmin && (
										<AccordionActions>
											<ButtonPrimary
												size="small"
												onClick={() => {
													setConfirmDialogMessageId(m.id);
													setConfirmDialogOption(CancelOptions.Scheduled);
													setConfirmDialogOpen(true);
												}}
											>
												{strings.cancelScheduledBtn}
											</ButtonPrimary>
										</AccordionActions>
									)}
							</Accordion>
						</React.Fragment>
					);
				})
			) : (
				<Typography>{strings.pendingTemplateMessage}</Typography>
			)}
			<Dialog open={confirmDialogOpen}>
				<DialogTitle>Cancel Message</DialogTitle>
				<DialogContent dividers>
					{confirmDialogOption === CancelOptions.All
						? strings.confirmCancelAll
						: confirmDialogOption === CancelOptions.Next
						? strings.confirmCancelNext
						: strings.confirmCancelScheduled}
				</DialogContent>
				<DialogActions>
					<Button
						onClick={() => setConfirmDialogOpen(false)}
						className="cancelBtn"
					>
						{strings.closeDialogBtn}
					</Button>
					<ButtonPrimary
						onClick={() => cancelRecurringRuns()}
						className="deleteBtn"
					>
						{strings.confirmDialogBtn}
					</ButtonPrimary>
				</DialogActions>
			</Dialog>
		</div>
	);
};
